// services/projectService.js
import { supabase } from "../lib/supabaseClient"

export const projectService = {
  // Get all projects
  async getAllProjects() {
    const { data, error } = await supabase
      .from('projects')
      .select('*')
    
    if (error) throw error
    
    // Convert to GeoJSON format
    return {
      type: "FeatureCollection",
      name: "Projects and Places",
      features: data.map(project => ({
        type: "Feature",
        properties: {
          nom_etablissement: project.nom_etablissement,
          fiche_agence: project.fiche_agence,
          titre_affiche: project.titre_affiche,
          adresse: project.adresse,
          interior_designers: project.interior_designers,
          points_of_interest: project.points_of_interest,
          design_events: project.design_events,
          design_points_of_sales: project.design_points_of_sales,
          annee_projet: project.annee_projet,
          description_projet: project.description_projet,
          date_vernissage: project.date_vernissage,
          heure_vernissage: project.heure_vernissage,
          date_debut_expo: project.date_debut_expo,
          date_fin_expo: project.date_fin_expo,
          site_web: project.site_web,
          credits_photo: project.credits_photo,
          photos_projet: project.photos_projet
        },
        geometry: {
          type: "Point",
          coordinates: [project.longitude, project.latitude]
        }
      }))
    }
  },

  // Add a single project
  async addProject(projectData) {
    const { data, error } = await supabase
      .from('projects')
      .insert([projectData])
    
    if (error) throw error
    return data
  },

  // Upload CSV
  // Add this to your projectService.js to help with debugging
async uploadCSV(file) {
  console.log('Starting CSV upload process');
  
  return new Promise((resolve, reject) => {
      const reader = new FileReader();
      
      reader.onload = async (e) => {
          try {
              const text = e.target.result;
              console.log('CSV content preview:', text.substring(0, 200));
              
              const rows = text.split('\n');
              console.log('Number of rows:', rows.length);
              
              const headers = rows[0].split(',');
              console.log('Headers:', headers);
              
              const projects = rows.slice(1).map(row => {
                  const values = row.split(',');
                  const project = {};
                  
                  headers.forEach((header, index) => {
                      project[header.trim()] = values[index]?.trim() || '';
                  });
                  
                  return project;
              });
              
              console.log('Parsed projects:', projects);
              
              const { data, error } = await supabase
                  .from('projects')
                  .insert(projects);
              
              if (error) {
                  console.error('Supabase error:', error);
                  reject(error);
                  return;
              }
              
              console.log('Upload successful:', data);
              resolve(data);
          } catch (error) {
              console.error('Processing error:', error);
              reject(error);
          }
      };
      
      reader.onerror = (error) => {
          console.error('File reading error:', error);
          reject(error);
      };
      
      reader.readAsText(file);
  });
}
}